const allAreTruthy = (array) => {
  const hasAFalsyValue = array.some((item) => !item);
  return !hasAFalsyValue;
};

export default allAreTruthy;
